import { IOrganiser } from "@evennt-tech/api-v2-core";
import {
  ContentState,
  convertFromRaw,
  convertToRaw,
  EditorState,
  RawDraftContentState,
} from "draft-js";
import { CommentAuthor } from "ts/api/standTask/comment/comment";

const updateEntityData = (
  contentState: ContentState,
  entityKey: string,
  newData: Record<string, any>
) => {
  return contentState.mergeEntityData(entityKey, newData);
};
export const updateMentions = (
  rawContent: RawDraftContentState,
  organisers?: { id: string; name: string }[]
) => {
  let contentState = convertFromRaw(rawContent);
  if (!organisers?.length) {
    return contentState;
  }

  contentState.getBlockMap().forEach((block) => {
    block?.findEntityRanges(
      (character) => {
        const entityKey = character.getEntity();
        if (entityKey) {
          const entity = contentState.getEntity(entityKey);

          if (entity.getType() === "mention" && organisers.length) {
            const mentionData = entity.getData().mention;
            const user = organisers.find((org) => org.id === mentionData.id);
            if (user && mentionData.name !== user.name) {
              contentState = updateEntityData(contentState, entityKey, {
                mention: {
                  ...mentionData,
                  name: user.name,
                },
              });
              return true;
            }
          }
        }
        return false;
      },
      () => null
    );
  });
  return contentState;
};
export const getRawContent = (editorState: EditorState) => {
  const editorContent = editorState.getCurrentContent();
  return convertToRaw(editorContent);
};
export const extractMentions = (rawContent: RawDraftContentState) => {
  const mentions: string[] = [];
  rawContent.blocks.forEach((block) => {
    block.entityRanges.forEach((range) => {
      const { key } = range;
      const entity = rawContent.entityMap[key];
      if (entity.type !== "mention") {
        return;
      }
      const { mention } = entity.data;

      mentions.push(mention.id);
    });
  });
  return mentions;
};
export const isCommentEmpty = (content?: string) => {
  if (!content) {
    return true;
  }
  const rawContent = JSON.parse(content);
  return !convertFromRaw(rawContent).getPlainText().length;
};

export const getCommentAuthorInfo = (
  organiserId: string,
  showOrganisers?: IOrganiser[]
): CommentAuthor | null => {
  if (!showOrganisers?.length) {
    return null;
  }

  const organiser = showOrganisers.find((org) => org.id === organiserId);

  if (!organiser) {
    return null;
  }

  const organiserCompany =
    organiser?.organiserCompanyToOrganisers?.[0]?.organiserCompany;

  return {
    id: organiserId,
    email: organiser.user?.email as string,
    name: organiser.contactPerson,
    companyName: organiserCompany?.name ?? "",
    ...(organiserCompany?.logo?.url && { logo: organiserCompany?.logo?.url }),
  };
};
